
    export default 
    {
    "new_feature": {
        "csv_bulk_order": "Ordine all'ingrosso CSV",
        "describe": "Per utenti che non utilizzano il servizio Shopify"
    }
}